import find from "lodash/find";
import { ActivityPureCustomValue, Id, PureCustomValueCamelCased } from "PFTypes";

export const getLocalCustomValue = (
  values: ActivityPureCustomValue[],
  customValueId: Id | null
): PureCustomValueCamelCased | undefined => {
  const createdValue = find(values, (value) => !!value.created && value.id === customValueId);

  if (!createdValue) {
    return undefined;
  }

  return { ...createdValue, text: String(createdValue.text || createdValue.value) };
};
